import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSunsetArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSunsetArrowDown"><Path d="M2.75391 20.25H21.2539M12 8V2.75M2.75 16.25H4.25M19.75 16.25H21.25M17.9375 11.0184L19.0866 10.0542M4.91406 10.0542L6.06313 11.0184M9.5 6L12 8.5L14.5 6M7.75 16.25V16C7.75 13.6528 9.65279 11.75 12 11.75C14.3472 11.75 16.25 13.6528 16.25 16V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSunsetArrowDown;
